import requestApi from "@/utils/requestApi";

let quantityTimer = null;

export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    userType: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      num: 1,
      colors: ["#fe5301", "#fe5301", "#fe5301"],
      scLink: process.env.VUE_APP_APP,
      popperShowLoading: false,
    };
  },
  methods: {
    /* 商品选择 */
    goodsCheckbox(isCheck, goods, index) {
      if (isCheck && Number(goods.quantity) < Number(goods.minOrderQuantity)) {
        goods.checked = false;
        this.$message.warning("起订量不足");
        return;
      }

      const { list } = this;

      if (Number(goods.quantity) > Number(goods.currQuantity)) {
        goods.checked = false;
        this.$message.warning("库存不足");
      }
      const carItemList = list[index].carItemList;
      const goodsList = carItemList.filter(
        (goods) => goods.upDownStatus && goods.currPrice && goods.originalPrice && Number(goods.quantity) >= Number(goods.minOrderQuantity)
      );
      list[index].checked = false;
      list[index].indeterminate = false;
      if (goodsList.every((goods) => goods.checked)) {
        list[index].checked = true;
        list[index].indeterminate = false;
      } else if (goodsList.some((goods) => goods.checked)) {
        list[index].indeterminate = true;
      }
      this.$emit("update:list", list);
    },
    /* 店铺选择 */
    shopCheckbox(isCheck, index) {
      const { list } = this;
      if (isCheck) {
        list[index].carItemList.forEach((item) => {
          if (item.upDownStatus && item.currPrice && item.originalPrice && Number(item.quantity) <= Number(item.currQuantity)) {
            item.checked = true;
          }
        });
      } else {
        list[index].carItemList.forEach((item) => {
          item.checked = false;
        });
      }
    },
    /* 是否全选 */
    isCheckedAll(item) {
      const goodsList = item.carItemList.filter((goods) => goods.upDownStatus && goods.currPrice && goods.originalPrice);
      if (goodsList.length && (item.checked || goodsList.every((goods) => goods.checked))) {
        return true;
      }

      return false;
    },
    /* 删除 */
    del(argGoods, shopIndex, goodsIndex) {
      const { skuId, skuName } = argGoods;
      this.$confirm(`您确定要删除『${skuName}』吗？`, "提示", {
        type: "warning",
      }).then(async () => {
        const loading = this.$loading({
          lock: false,
          text: "加载中...",
        });

        const { msg, code } = await requestApi.post("sctrading/shoppingCart/deleteGoods", {
          skuIdList: [skuId],
        });

        if (code == "0") {
          const { list } = this;
          const { carItemList } = list[shopIndex];
          if (carItemList.length == 1) {
            list.splice(shopIndex, 1);
          } else {
            list[shopIndex].carItemList.splice(goodsIndex, 1);
          }

          this.$emit("update:list", list);
          this.$message({
            type: "success",
            message: "删除成功",
          });
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }

        loading.close();
      });
    },
    /* 小计 */
    amount(goods) {
      const { currPrice, quantity } = goods;

      return (Number(currPrice) * Number(quantity)).toFixed(2);
    },
    /* 小计优惠 */
    amountDiscount(goods) {
      const { currPrice, quantity, originalPrice } = goods;

      return ((Number(originalPrice) - Number(currPrice)) * Number(quantity)).toFixed(2);
    },
    /* 数量修改 */
    quantityblur(event, goods) {
      let { value } = event.target;
      if (value == "") {
        event.target.value = 1;
        goods.quantity = 1;
      }
    },
    quantityInput(event) {
      let { value } = event.target;
      if (value == "") {
        event.target.value = "";
        return;
      }

      let valueStr = `${value}`;
      valueStr = valueStr.replace(/[^\d.]/g, "");
      valueStr = valueStr.replace(/\.{2,}/g, ".");
      valueStr = valueStr.replace(".", "$#$");
      valueStr = valueStr.replace(/\./g, "");
      valueStr = valueStr.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      valueStr = valueStr.replace(reg, "$1$2.$3");
      if (valueStr.indexOf(".") < 0 && valueStr !== "" && valueStr !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        valueStr = parseFloat(valueStr);
      }
      event.target.value = valueStr;
    },
    quantityChange(currentValue = 1, oldValue, skuId, shopIndex, goodsIndex) {
      const { list } = this;
      const { currQuantity } = list[shopIndex].carItemList[goodsIndex];
      if (!(Number(currentValue) <= Number(currQuantity))) {
        list[shopIndex].carItemList[goodsIndex].disabled = false;
      }
      quantityTimer && clearTimeout(quantityTimer);

      quantityTimer = setTimeout(async () => {
        const loading = this.$loading({
          lock: false,
          text: "",
          spinner: " ",
          background: "rgba(0, 0, 0, 0)",
        });
        const { exception, data, code } = await requestApi.post("sctrading/shoppingCart/updateGoodsQuantity", {
          skuId,
          quantity: currentValue,
        });

        if (code != "0") {
          this.$message({
            type: "error",
            message: exception,
          });

          if (code == "432004") {
            list[shopIndex].carItemList[goodsIndex].checked = false;
            // list[shopIndex].carItemList[goodsIndex].disabled = true;
            list[shopIndex].carItemList[goodsIndex].quantity = data;
          }
        }
        loading.close();
      }, 500);
    },
    /* 活动名称 */
    activityName(goods) {
      if (goods.promotionType == "DIRECT_SELLING") {
        return `直降${goods.preferentialValue}元`;
      }
      // if (goods.promotionType == "BUY_GIFTS") {
      //   return `买${goods.buyGoodsQuantity}赠${goods.giftQuantity}`;
      // }
      if (goods.promotionType == "DISCOUNT") {
        return `已享${goods.preferentialValue}折`;
      }
      return "";
    },
    /* 更换规格 */
    specsChange(goods, shopIndex, goodsIndex) {
      this.$store.commit("cart/saveSpecsInfo", {
        goods,
        visible: true,
        shopIndex,
        goodsIndex,
      });
    },
    /* 进入店铺 */
    goUrl(url) {
      window.open(`${this.scLink}${url}`);
    },
    /* 赠品数量 */
    giftGoodsNum(data, quantity) {
      const { giftQuantity, buyQuantity, promotionLimitation, giftedQuantity } = data;
      let limitation = (Math.floor(quantity / buyQuantity) * giftQuantity).toFixed(0);

      let maxNum = 0;
      if (Number(limitation) > promotionLimitation - giftedQuantity) {
        maxNum = promotionLimitation - giftedQuantity;
      } else {
        maxNum = Number(limitation);
      }
      // if (maxNum > Number(giftRemain)) {
      //   maxNum = giftRemain;
      // }
      return maxNum;
    },
    /* 领取显示 */
    popperShow() {
      // this.popperShowLoading = true;
    },
    /* 领取 */
    async popperGetCoupon(coupon, data, index, couponIndex) {
      const { regCode } = coupon;
      const { shopId } = data;

      const loading = this.$loading({
        lock: false,
        text: "领券中...",
      });

      const {
        exception,
        data: data2,
        code,
      } = await requestApi.post("trading/coupon/collecting", {
        regCode,
        busId: shopId,
      });

      console.log(exception, data2, code);

      if (code == "0") {
        Promise.all([
          requestApi.post("sctrading/shop/coupon/selMyList", {
            platformType: "SC",
            cpChannel: "SHOP",
          }),
          requestApi.post("sctrading/shop/coupon/selMyList", {
            platformType: "SC",
            cpChannel: "PLATFORM",
          }),
        ]).then(([shopRes, platformRes]) => {
          const { list } = this;
          const { data: shopData } = shopRes;
          const { data: platformData } = platformRes;
          let couponMyPlatformList = [];

          if (shopData && shopData.length) {
            shopData.forEach((item) => {
              item.shopCouponList = item.shopCouponList.map((coupon) => ({
                ...coupon,
                myCoupon: true,
              }));
            });
            this.$emit("update:couponMyShopList", shopData);
          }

          if (platformData && platformData[0] && platformData[0].shopCouponList && platformData[0].shopCouponList.length) {
            couponMyPlatformList = platformData[0].shopCouponList.map((item) => ({
              ...item,
              busType: "platform",
              myCoupon: true,
            }));

            this.$emit("update:couponMyPlatformList", couponMyPlatformList);
          }

          list.forEach((item) => {
            item.shopCouponList = item.shopCouponList.filter((coupon) => coupon.myCoupon !== true);
          });

          list.forEach((item) => {
            const couponMyShopListIndex = shopData.findIndex((couponItem) => couponItem.busId == item.shopId);
            if (couponMyShopListIndex != -1) {
              if (item.shopCouponList && item.shopCouponList.length) {
                item.shopCouponList = [...item.shopCouponList, ...shopData[couponMyShopListIndex].shopCouponList];
              } else {
                item.shopCouponList = [...shopData[couponMyShopListIndex].shopCouponList];
              }
            }

            if (couponMyPlatformList && couponMyPlatformList.length) {
              if (item.shopCouponList && item.shopCouponList.length) {
                item.shopCouponList = [...item.shopCouponList, ...couponMyPlatformList];
              } else {
                item.shopCouponList = [...couponMyPlatformList];
              }
            }
          });

          this.$emit("update:list", list);

          this.$message({
            type: "success",
            message: "领取成功",
          });

          loading.close();
        });
      } else {
        let couponText = "已领取至上限";
        if (code == "1002" || code == "1003" || code == "1004" || code == "1005") {
          const { list } = this;
          list[index].shopCouponList[couponIndex].isCouponLimit = true;
          if (code == "1002" || code == "1003") {
            couponText = "已失效";
          }
          if (code == "1004") {
            couponText = "数量不足，领取失败";
          }
          list[index].shopCouponList[couponIndex].couponText = couponText;
          this.$emit("update:list", list);
        }
        loading.close();
        this.$message({
          type: "error",
          message: exception,
        });
      }
    },
    /* 已领取 */
    receivedCoupon(list) {
      const listTem = list.filter((item) => item.myCoupon);
      return listTem.length;
    },
    /* 去使用 */
    useCoupon(data) {
      const { cpId, busId, busType, subBusId, regDesc, cpChannel } = data;
      /* 支持全店铺 */
      if (subBusId.indexOf("SHOP#FFFF") !== -1) {
        this.goUrl(`goods/queryGoodsInfo.do?shopIds=""&couPonStr=${regDesc}`);
        return;
      }

      if (busType == "SHOP") {
        if (subBusId.split(",").length > 1) {
          this.goUrl(`goods/queryGoodsInfo.do?shopIds=${subBusId}&couPonStr=${regDesc}`);
        } else {
          this.goUrl(`shopInfo/shopInfoList.do?shopId=${subBusId}&couPonStr=${regDesc}`);
        }
      } else if (busType == "GOODS") {
        if (cpChannel == "PLATFORM") {
          this.goUrl(`goods/queryGoodsInfo.do?platformCouponId=${cpId}&couPonStr=${regDesc}`);
        }
        if (subBusId.split(",").length > 1) {
          this.goUrl(`shopInfo/shopInfoList.do?linkIds=${subBusId}&couPonStr=${regDesc}&shopId=${busId}`);
        } else {
          this.goUrl(`goods/queryGoodsDetailInfo/${subBusId}`);
        }
      } else if (busType == "CATE") {
        this.goUrl(`goods/queryGoodsInfo.do?linkIds=${subBusId}&couPonStr=${regDesc}&shopId=${busId}`);
      }
    },
  },
};
